import css from 'styled-jsx/css';

const styles = css.global`#den-fraudes-mudanca-razao-social {
    background: #DEEDF2;
    padding: 40px 0;
}

#den-fraudes-mudanca-razao-social .ctn-home-24 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
}

#den-fraudes-mudanca-razao-social .den-fraudes-mudanca-razao-social-textos {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#den-fraudes-mudanca-razao-social .mudanca-razao-social-titulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    margin: 0;
}

#den-fraudes-mudanca-razao-social .mudanca-razao-social-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

#den-fraudes-mudanca-razao-social .mudanca-razao-social-texto b {
    font-weight: 600;
}

@media (min-width: 992px) {
    #den-fraudes-mudanca-razao-social {
        padding: 48px 0;
    }
    #den-fraudes-mudanca-razao-social .ctn-home-24 {
        flex-direction: row;
        gap: 72px;
    }
}`;

export default styles;